import type { ComponentStyleConfig } from '@chakra-ui/react';

import { paragraphSemiBold } from '../typography';

const AvatarComponentStyle: ComponentStyleConfig = {
  baseStyle: {
    label: {
      ...paragraphSemiBold(),
      color: 'white',
    },
    container: {
      bg: 'primary400',
    },
  },
};

export default AvatarComponentStyle;
